<app-card>
  <div class="flex flex-col gap-8">
    <div class="flex flex-nowrap gap-1 w-full">
      <app-input class="flex-grow" [formControl]="searchControl" placeholder="{{ 'page.project-detail-point-clouds.list.search.placeholder' | translate }}" icon="/assets/images/icon-search.svg"></app-input>
      <app-select class="w-52" [options]="sortOptions" [formControl]="sortControl" label="{{ 'table.sort-by' | translate }}"></app-select>

      <div class="relative w-72 flex-shrink-0" *ngIf="selection.length > 0">
        <app-select label="{{ 'page.project-detail-point-clouds.list.selected.label' | translate }}" [formControl]="downloadControl" [options]="downloadOptions"></app-select>

        <div class="absolute top-0 bottom-0 flex items-center right-8 text-primary-one transition-opacity" [class.opacity-0]="!downloading">
          <app-loader></app-loader>
        </div>
      </div>
    </div>

    <app-table (selectionChange)="updateSelection($event)" [selectable]="true" [columns]="columns" [data]="data$ | async" (pageChange)="changePage($event)"></app-table>
  </div>
</app-card>
